var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.items, function (item) {
        return _c(
          "a-row",
          { style: { margin: "12px" }, attrs: { gutter: 4 } },
          [
            _c(
              "a-col",
              { attrs: { span: 20 } },
              [
                _c("a-input", {
                  attrs: { placeholder: _vm.placeholder },
                  model: {
                    value: item.name,
                    callback: function ($$v) {
                      _vm.$set(item, "name", $$v)
                    },
                    expression: "item.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-col",
              { attrs: { span: 4 } },
              [
                _c(
                  "a-button",
                  {
                    attrs: { type: "link" },
                    on: {
                      click: function ($event) {
                        return _vm.removeItem(item)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "a-row",
        [
          _c(
            "a-col",
            { attrs: { span: 24 } },
            [
              _c(
                "a-button",
                {
                  attrs: { type: "link", icon: "download" },
                  on: { click: _vm.addItem },
                },
                [_vm._v(" " + _vm._s(_vm.addLabel) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }